import { Box, DashPlaceholder, Flex, Image, Text } from "dash-ui";
import { useMemo } from "react";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";

import { GetPropertyByIdQuery } from "gql/generated.graphql";

import { getPropertiesDataToView } from "./PropertiesClusterInfo.helpers";

const PropertiesClusterInfo = ({
  properties,
}: {
  properties: GetPropertyByIdQuery["getPropertyById"][];
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { propertyToView, buildingTypesText } = useMemo(
    () => getPropertiesDataToView(properties, t),
    [properties, t]
  );
  const hasPriceRange =
    propertyToView?.priceRange?.max && propertyToView?.priceRange?.min;

  return (
    <Box p={2} w={233}>
      <Box h={125} mb={2}>
        {propertyToView?.mainPropertyMediaFile ? (
          <Image
            size="100%"
            src={
              propertyToView.mainPropertyMediaFile.files[0].thumbnailFile
                ?.publicUrl ||
              propertyToView.mainPropertyMediaFile.files[0].thumbnailFileUrl ||
              ""
            }
          />
        ) : (
          <DashPlaceholder w="100%" h="100%" />
        )}
      </Box>
      <Flex mb={1.5} alignItems="center">
        {!hasPriceRange && (
          <Box mr={1}>
            <Text color={theme.colors.n90} semibold>
              {t("pages:propertyPage.from")}:
            </Text>
          </Box>
        )}
        <Text color={theme.colors.n90} semibold>
          ${propertyToView?.priceRange?.min?.toLocaleString("en")}
        </Text>
        {hasPriceRange && (
          <>
            <Box mx={1}>
              <Text color={theme.colors.n90} semibold>
                {t("common:labels.to")}
              </Text>
            </Box>
            <Text color={theme.colors.n90} semibold>
              ${propertyToView?.priceRange?.max?.toLocaleString("en")}
            </Text>
          </>
        )}
      </Flex>
      <Flex>
        <Text color={theme.colors.n80} sm>
          {buildingTypesText}
        </Text>
      </Flex>
    </Box>
  );
};

export default PropertiesClusterInfo;
